import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';

const EVENT_CONFIG = {
  MARKET_CRASH: { icon: 'TrendingDown', color: 'text-error', bg: 'bg-error/10 border-error/20', label: 'Market Crash' },
  BULL_RUN: { icon: 'TrendingUp', color: 'text-success', bg: 'bg-success/10 border-success/20', label: 'Bull Run' },
  FACTION_TOURNAMENT: { icon: 'Swords', color: 'text-accent', bg: 'bg-accent/10 border-accent/20', label: 'Faction Tournament' },
  STOCK_MULTIPLIER_EVENT: { icon: 'Zap', color: 'text-warning', bg: 'bg-warning/10 border-warning/20', label: 'Stock Multiplier' },
  LIQUIDITY_CRISIS: { icon: 'AlertTriangle', color: 'text-error', bg: 'bg-error/10 border-error/20', label: 'Liquidity Crisis' },
  DIVIDEND_BONANZA: { icon: 'DollarSign', color: 'text-success', bg: 'bg-success/10 border-success/20', label: 'Dividend Bonanza' },
};

const useCountdown = (endDate) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calc = () => {
      const diff = new Date(endDate) - new Date();
      if (diff <= 0) { setTimeLeft('Ended'); return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft(`${h}h ${m}m ${s}s`);
    };
    calc();
    const id = setInterval(calc, 1000);
    return () => clearInterval(id);
  }, [endDate]);

  return timeLeft;
};

const EventCard = ({ event }) => {
  const config = EVENT_CONFIG?.[event?.event_type] || EVENT_CONFIG?.BULL_RUN;
  const countdown = useCountdown(event?.event_end);

  return (
    <div className={`card p-4 border ${config?.bg} transition-all hover:scale-[1.01]`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className={`p-2 rounded-lg ${config?.bg}`}>
            <Icon name={config?.icon} size={18} className={config?.color} />
          </div>
          <div>
            <p className="font-semibold text-foreground text-sm">{event?.event_name || config?.label}</p>
            <p className="text-xs text-muted">{config?.label}</p>
          </div>
        </div>
        <div className="text-right">
          <div className={`text-sm font-bold ${config?.color}`}>
            {event?.multiplier_value > 1 ? `×${event?.multiplier_value}` : event?.multiplier_value < 1 ? `×${event?.multiplier_value}` : 'Active'}
          </div>
          <div className="text-xs text-muted">multiplier</div>
        </div>
      </div>
      <p className="text-xs text-muted mb-3">{event?.description || 'Active seasonal event affecting market conditions.'}</p>
      {event?.affected_stocks?.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-muted mb-1">Affected Stocks:</p>
          <div className="flex flex-wrap gap-1">
            {event?.affected_stocks?.slice(0, 5)?.map((s) => (
              <span key={s} className="px-1.5 py-0.5 bg-surface-700 rounded text-xs text-foreground font-mono">{s}</span>
            ))}
            {event?.affected_stocks?.length > 5 && (
              <span className="px-1.5 py-0.5 bg-surface-700 rounded text-xs text-muted">+{event?.affected_stocks?.length - 5} more</span>
            )}
          </div>
        </div>
      )}
      <div className="flex items-center justify-between text-xs">
        <div className="flex items-center gap-1 text-muted">
          <Icon name="Clock" size={12} />
          <span>Ends in: <span className="text-foreground font-medium">{countdown}</span></span>
        </div>
        <div className={`px-2 py-0.5 rounded-full text-xs font-medium ${config?.bg} ${config?.color}`}>
          ACTIVE
        </div>
      </div>
    </div>
  );
};

export default EventCard;
